import React, { useState, useEffect } from 'react'

import AppDialog from 'components/AppDialog'

import api, { AppConfigParam, AppConfigParamOption } from 'api'
import { Icon, message } from 'antd'
import { AppTable } from 'components/AppTable/AppTable'
import AppMessage from 'components/AppMessage'
import { AppInput } from 'components/AppFormItem'
interface Props {
	scope: number
	paramConfigGroup: any
	afterSave: () => void
}
export let ParamConfigEdit = (props: Props) => {
	const [appConfigParam, setAppConfigParam] = useState({} as AppConfigParam)
	const [selectValue, setSelectValue] = useState()
	const [appConfigParamOption, setAppConfigParamOption] = useState([] as AppConfigParamOption[])
	const refForm = React.createRef<HTMLDivElement>()
	const refTable = React.createRef<AppTable>()
	const close = () => {
		AppDialog.close()
	}
	const saveParamConfig = async () => {
		let data = {} as AppConfigParam
		data.type = selectValue
		data.scope = props.scope
		data.groupId = props.paramConfigGroup.id
		data.application = props.paramConfigGroup.application
		let usefulAppConfigParamOption = appConfigParamOption
			.filter(e => {
				return e.value !== '' && e.text !== ''
			})
			.map(e => {
				if (e.id < 0) {
					e.id = null
					return e
				} else {
					return e
				}
			})
		if (selectValue === 3 && !usefulAppConfigParamOption.length) {
			message.error('单选类参数需要传入选项!')
			return
		}
		if (selectValue === 3) {
			data.appConfigParamOptionList = usefulAppConfigParamOption
		}
		let res = await api.modeling.param.saveConfigParam(data)
		if (res.result) {
			message.success('保存成功！')
			close()
			props.afterSave && props.afterSave()
		} else {
			message.error(res.msg)
		}
	}
	const change = (value: any) => {
		setSelectValue(value)
	}
	const refreshTable = () => {
		refTable && refTable.current && refTable.current.fetchDataSource(appConfigParamOption)
	}
	useEffect(() => {
		refreshTable()
	}, [appConfigParamOption])

	const addOption = () => {
		let idsj = -new Date().getTime()
		let option = {
			id: idsj,
			value: '',
			text: '',
		}
		appConfigParamOption.push(option)
		refreshTable()
	}
	const deleteOption = async (data: AppConfigParamOption) => {
		let res = await AppMessage.confirm('您确定要删除该记录吗？', true)
		if (res) {
			console.log(data.id)
			let newAppConfigParamOption = appConfigParamOption.filter(e => {
				console.log('e', e.id)
				return e.id !== data.id
			}) as AppConfigParamOption[]
			setAppConfigParamOption(newAppConfigParamOption)
		}
	}
	const editAppConfigParamOption = () => {
		return selectValue === 3 ? (
			<AppTable dataSource={appConfigParamOption} ref={refTable} paging={false}>
				<AppTable.ColIndex title="序号" />
				<AppTable.ColEdit title="标识符" field="value" />
				<AppTable.ColEdit title="文本" field="text" />
				<AppTable.ColAction
					render={(data: AppConfigParamOption) => {
						return (
							<React.Fragment>
								{/* <TableAction
									onClick={() => {
										deleteOption(data)
									}}
									label="删除"
								/> */}
							</React.Fragment>
						)
					}}
				/>
			</AppTable>
		) : (
			''
		)
	}
	return (
		<div className="app-dialog-form-container">
			{/* <div className="app-dialog-form">
                <div
                className="app-form"
                
                ref={refForm}
               
        
                 >
                     <AppInput
                        label="参数名称"
                        field="showName"
                        placeholder="请输入参数名称"
                        value = {appConfigParam.showName}
                        req
                    />
                    <AppInput
                        label="唯一标识"
                        field="keyName"
                        placeholder="请输入唯一标识,建议系统编码_标识，例如00_test"
                        value = {appConfigParam.keyName}
                        req
                    />
                    <AppFormSelect
                        label="参数类型"
                        field="type"
                        value={appConfigParam.type}
                        onChange={change}
                        appFormItemOptionList={[{label:"文本输入",value:0},{label:"数值输入",value:1},{label:"日期",value:2},{label:"单选框",value:3}]}
                    />
                    <AppInput
                        label="权限Code"
                        field="actionCode"
                        placeholder="请输入2位编码,例如：01"
                        value = {appConfigParam.actionCode}
                    />
                    <AppInput
                        label="排序Code"
                        field="sort"
                        placeholder="请输入排序编码，建议与唯一标识保持一致,如:00_test1"
                        value = {appConfigParam.sort}
                    />
                    <AppTextArea
                        label="参数描述"
                        field="describe"
                        value={appConfigParam.describe}
                    />
                 </HTMLDivElement>
                    {selectValue===3?<div >
                        <span>值域</span>
                        <span  onClick={addOption}>
                        <Icon type="plus-circle" theme="twoTone" />新增
                        </span>
                    </div>:""
                 } {editAppConfigParamOption()}
            </div>
            <AppFormMenu>
                <AppAction title="取消" type="default" action={close} />
                <AppAction title="确定" type="primary"action={saveParamConfig}/>
            </AppFormMenu> */}
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/param/components/ParamConfigEdit.tsx